const styles = (theme) => ({
  progress: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    marginLeft: -25,
    marginTop: -25,
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  root: {
    '& .ItemIcon': {
      backgroundColor: theme.palette.background.lighter,
    },
  },
  gridItemLast: {
    marginBottom: theme.spacing.unit,
    '&&': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  bottomText: {
    '&&': {
      fontSize: '1.125rem',
      margin: `${theme.spacing.unit}px 0 0`,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.25rem',
      },
    },
  },
  topButtonsContainer: {
    textAlign: 'right',
  },
  topButtonContainer: {
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
      marginLeft: theme.spacing.unit * 4,
    },
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  buttonSubmit: {
    marginRight: 0,
  },
  title: {
    paddingTop: 0,
  },
  avatar: {
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    color: theme.palette.primary.dark,
    borderRadius: '100px',
    boxSizing: 'content-box',
    padding: '15px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: '20px',
    },
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '10px 0',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  },
});

export default styles;
